export const translations = {
  fr: {
    // Navigation
    home: 'Accueil',
    surgeries: 'Interventions',
    quote: 'Devis Gratuit',
    contact: 'Contact',
    
    // Home Page
    heroTitle: 'Excellence Médicale en Tunisie',
    heroSubtitle: 'Des soins de qualité internationale à des prix abordables. Profitez d\'une prise en charge complète pour votre parcours médical.',
    getQuote: 'Demander un Devis',
    learnMore: 'En Savoir Plus',
    
    whyChooseUs: 'Pourquoi Nous Choisir',
    experiencedDoctors: 'Médecins Expérimentés',
    experiencedDoctorsDesc: 'Des chirurgiens qualifiés avec une expertise internationale',
    modernFacilities: 'Installations Modernes',
    modernFacilitiesDesc: 'Hôpitaux équipés des dernières technologies médicales',
    affordablePrices: 'Prix Abordables',
    affordablePricesDesc: 'Économisez jusqu\'à 70% par rapport aux prix européens',
    completeSupport: 'Accompagnement Complet',
    completeSupportDesc: 'Prise en charge totale: transferts, hébergement, suivi',
    
    ourServices: 'Nos Services',
    viewAllSurgeries: 'Voir Toutes les Interventions',
    
    readyToStart: 'Prêt à Commencer Votre Parcours?',
    readyToStartDesc: 'Contactez-nous dès aujourd\'hui pour un devis personnalisé et gratuit',
    contactUs: 'Nous Contacter',
    
    // Surgeries Page
    allSurgeries: 'Toutes les Interventions',
    allCategories: 'Toutes Catégories',
    searchPlaceholder: 'Rechercher une intervention...',
    noSurgeriesFound: 'Aucune intervention trouvée',
    duration: 'Durée',
    days: 'jours',
    recovery: 'Récupération',
    from: 'À partir de',
    
    // Surgery Detail
    backToSurgeries: 'Retour aux Interventions',
    description: 'Description',
    included: 'Inclus dans le Package',
    requestQuote: 'Demander un Devis',
    
    // Quote Form
    quoteFormTitle: 'Demande de Devis Personnalisé',
    quoteFormSubtitle: 'Remplissez ce formulaire et recevez une réponse sous 24h',
    fullName: 'Nom Complet',
    fullNamePlaceholder: 'Votre nom complet',
    email: 'Email',
    emailPlaceholder: 'votre@email.com',
    phone: 'Téléphone',
    phonePlaceholder: '+33 6 12 34 56 78',
    country: 'Pays',
    countryPlaceholder: 'Votre pays de résidence',
    preferredLanguage: 'Langue Préférée',
    selectLanguage: 'Sélectionner une langue',
    french: 'Français',
    english: 'English',
    arabic: 'العربية',
    surgeryInterested: 'Intervention Souhaitée',
    selectSurgery: 'Sélectionner une intervention',
    message: 'Message',
    messagePlaceholder: 'Décrivez votre situation et vos attentes...',
    submit: 'Envoyer la Demande',
    submitting: 'Envoi en cours...',
    quoteSuccess: 'Demande envoyée avec succès!',
    quoteSuccessDesc: 'Nous vous répondrons dans les 24 heures.',
    quoteError: 'Erreur lors de l\'envoi',
    
    // Contact Page
    contactTitle: 'Contactez-Nous',
    contactSubtitle: 'Nous sommes là pour répondre à toutes vos questions',
    subject: 'Sujet',
    subjectPlaceholder: 'Objet de votre message',
    sendMessage: 'Envoyer le Message',
    sending: 'Envoi...',
    contactSuccess: 'Message envoyé!',
    contactSuccessDesc: 'Nous vous répondrons rapidement.',
    contactError: 'Erreur lors de l\'envoi',
    
    // Footer
    aboutUs: 'À Propos',
    aboutUsDesc: 'Leader du tourisme médical en Tunisie, VIP Medicale Services offre des soins de qualité avec un accompagnement personnalisé.',
    quickLinks: 'Liens Rapides',
    followUs: 'Suivez-Nous',
    allRightsReserved: 'Tous droits réservés',
    
    // Categories
    esthetic: 'Chirurgie Esthétique',
    dental: 'Chirurgie Dentaire',
    bariatric: 'Chirurgie Bariatrique',
    orthopedic: 'Chirurgie Orthopédique',
    ophthalmology: 'Ophtalmologie',
    analysis: 'Analyses Médicales',
  },
  en: {
    // Navigation
    home: 'Home',
    surgeries: 'Procedures',
    quote: 'Free Quote',
    contact: 'Contact',
    
    // Home Page
    heroTitle: 'Medical Excellence in Tunisia',
    heroSubtitle: 'World-class healthcare at affordable prices. Enjoy complete support throughout your medical journey.',
    getQuote: 'Get a Quote',
    learnMore: 'Learn More',
    
    whyChooseUs: 'Why Choose Us',
    experiencedDoctors: 'Experienced Doctors',
    experiencedDoctorsDesc: 'Qualified surgeons with international expertise',
    modernFacilities: 'Modern Facilities',
    modernFacilitiesDesc: 'Hospitals equipped with latest medical technology',
    affordablePrices: 'Affordable Prices',
    affordablePricesDesc: 'Save up to 70% compared to European prices',
    completeSupport: 'Complete Support',
    completeSupportDesc: 'Full care: transfers, accommodation, follow-up',
    
    ourServices: 'Our Services',
    viewAllSurgeries: 'View All Procedures',
    
    readyToStart: 'Ready to Start Your Journey?',
    readyToStartDesc: 'Contact us today for a personalized free quote',
    contactUs: 'Contact Us',
    
    // Surgeries Page
    allSurgeries: 'All Procedures',
    allCategories: 'All Categories',
    searchPlaceholder: 'Search for a procedure...',
    noSurgeriesFound: 'No procedures found',
    duration: 'Duration',
    days: 'days',
    recovery: 'Recovery',
    from: 'From',
    
    // Surgery Detail
    backToSurgeries: 'Back to Procedures',
    description: 'Description',
    included: 'Included in Package',
    requestQuote: 'Request a Quote',
    
    // Quote Form
    quoteFormTitle: 'Request a Personalized Quote',
    quoteFormSubtitle: 'Fill out this form and receive a response within 24h',
    fullName: 'Full Name',
    fullNamePlaceholder: 'Your full name',
    email: 'Email',
    emailPlaceholder: 'your@email.com',
    phone: 'Phone',
    phonePlaceholder: '+1 234 567 8900',
    country: 'Country',
    countryPlaceholder: 'Your country of residence',
    preferredLanguage: 'Preferred Language',
    selectLanguage: 'Select a language',
    french: 'Français',
    english: 'English',
    arabic: 'العربية',
    surgeryInterested: 'Procedure of Interest',
    selectSurgery: 'Select a procedure',
    message: 'Message',
    messagePlaceholder: 'Describe your situation and expectations...',
    submit: 'Submit Request',
    submitting: 'Submitting...',
    quoteSuccess: 'Request sent successfully!',
    quoteSuccessDesc: 'We will respond within 24 hours.',
    quoteError: 'Error sending request',
    
    // Contact Page
    contactTitle: 'Contact Us',
    contactSubtitle: 'We are here to answer all your questions',
    subject: 'Subject',
    subjectPlaceholder: 'Subject of your message',
    sendMessage: 'Send Message',
    sending: 'Sending...',
    contactSuccess: 'Message sent!',
    contactSuccessDesc: 'We will reply shortly.',
    contactError: 'Error sending message',
    
    // Footer
    aboutUs: 'About Us',
    aboutUsDesc: 'Leader in medical tourism in Tunisia, VIP Medicale Services offers quality care with personalized support.',
    quickLinks: 'Quick Links',
    followUs: 'Follow Us',
    allRightsReserved: 'All rights reserved',
    
    // Categories
    esthetic: 'Esthetic Surgery',
    dental: 'Dental Surgery',
    bariatric: 'Bariatric Surgery',
    orthopedic: 'Orthopedic Surgery',
    ophthalmology: 'Ophthalmology',
    analysis: 'Medical Analysis',
  },
  ar: {
    // Navigation
    home: 'الرئيسية',
    surgeries: 'العمليات',
    quote: 'عرض مجاني',
    contact: 'اتصل بنا',
    
    // Home Page
    heroTitle: 'التميز الطبي في تونس',
    heroSubtitle: 'رعاية صحية بمستوى عالمي بأسعار معقولة. استمتع بالدعم الكامل طوال رحلتك الطبية.',
    getQuote: 'احصل على عرض',
    learnMore: 'اعرف المزيد',
    
    whyChooseUs: 'لماذا تختارنا',
    experiencedDoctors: 'أطباء ذوو خبرة',
    experiencedDoctorsDesc: 'جراحون مؤهلون بخبرة دولية',
    modernFacilities: 'مرافق حديثة',
    modernFacilitiesDesc: 'مستشفيات مجهزة بأحدث التقنيات الطبية',
    affordablePrices: 'أسعار معقولة',
    affordablePricesDesc: 'وفر حتى 70٪ مقارنة بالأسعار الأوروبية',
    completeSupport: 'دعم كامل',
    completeSupportDesc: 'رعاية شاملة: نقل، إقامة، متابعة',
    
    ourServices: 'خدماتنا',
    viewAllSurgeries: 'عرض جميع العمليات',
    
    readyToStart: 'هل أنت مستعد لبدء رحلتك؟',
    readyToStartDesc: 'اتصل بنا اليوم للحصول على عرض مجاني ومخصص',
    contactUs: 'اتصل بنا',
    
    // Surgeries Page
    allSurgeries: 'جميع العمليات',
    allCategories: 'جميع الفئات',
    searchPlaceholder: 'ابحث عن عملية...',
    noSurgeriesFound: 'لم يتم العثور على عمليات',
    duration: 'المدة',
    days: 'أيام',
    recovery: 'التعافي',
    from: 'من',
    
    // Surgery Detail
    backToSurgeries: 'العودة إلى العمليات',
    description: 'الوصف',
    included: 'متضمن في الباقة',
    requestQuote: 'طلب عرض سعر',
    
    // Quote Form
    quoteFormTitle: 'طلب عرض سعر مخصص',
    quoteFormSubtitle: 'املأ هذا النموذج واحصل على رد خلال 24 ساعة',
    fullName: 'الاسم الكامل',
    fullNamePlaceholder: 'اسمك الكامل',
    email: 'البريد الإلكتروني',
    emailPlaceholder: 'your@email.com',
    phone: 'الهاتف',
    phonePlaceholder: '123 456 789 +',
    country: 'البلد',
    countryPlaceholder: 'بلد إقامتك',
    preferredLanguage: 'اللغة المفضلة',
    selectLanguage: 'اختر اللغة',
    french: 'Français',
    english: 'English',
    arabic: 'العربية',
    surgeryInterested: 'العملية المطلوبة',
    selectSurgery: 'اختر عملية',
    message: 'الرسالة',
    messagePlaceholder: 'صف حالتك وتوقعاتك...',
    submit: 'إرسال الطلب',
    submitting: 'جاري الإرسال...',
    quoteSuccess: 'تم إرسال الطلب بنجاح!',
    quoteSuccessDesc: 'سنرد خلال 24 ساعة.',
    quoteError: 'خطأ في الإرسال',
    
    // Contact Page
    contactTitle: 'اتصل بنا',
    contactSubtitle: 'نحن هنا للإجابة على جميع أسئلتك',
    subject: 'الموضوع',
    subjectPlaceholder: 'موضوع رسالتك',
    sendMessage: 'إرسال الرسالة',
    sending: 'جاري الإرسال...',
    contactSuccess: 'تم إرسال الرسالة!',
    contactSuccessDesc: 'سنرد قريباً.',
    contactError: 'خطأ في الإرسال',
    
    // Footer
    aboutUs: 'معلومات عنا',
    aboutUsDesc: 'رائدون في السياحة الطبية في تونس، VIP Medicale Services تقدم رعاية عالية الجودة مع دعم شخصي.',
    quickLinks: 'روابط سريعة',
    followUs: 'تابعنا',
    allRightsReserved: 'جميع الحقوق محفوظة',
    
    // Categories
    esthetic: 'الجراحة التجميلية',
    dental: 'جراحة الأسنان',
    bariatric: 'جراحة السمنة',
    orthopedic: 'جراحة العظام',
    ophthalmology: 'طب العيون',
    analysis: 'التحاليل الطبية',
  }
};

export const t = (key, lang = 'fr') => {
  return translations[lang]?.[key] || key;
};